<form
  #quizFormElement
  class="learning-quiz-form"
  [formGroup]="quizForm"
  (ngSubmit)="onSubmit()"
  focusInvalidInput
  novalidate
>
  <fieldset class="form-fieldset">
    <legend class="c11n-text-md form-intro">
      {{ 'studentLearningQuiz.form.intro' | translate }}
    </legend>
    <div class="form-fields">
      <div class="form-field">
        <label c11n-label for="learningQuizRole">
          {{ 'studentLearningQuiz.form.role_label' | translate }}
        </label>
        <c11n-select
          [hideLabel]="true"
          [hintText]="''"
          [hasError]="hasError('role')"
          errorText="{{ 'studentLearningQuiz.form.role_required' | translate }}"
        >
          <select
            c11nSelectInput
            required
            id="learningQuizRole"
            name="role"
            formControlName="role"
            [attr.aria-invalid]="hasError('role')"
          >
            <option value="" data-option="placeholder" disabled selected>
              {{ 'formFields.select' | translate }}
            </option>
            <option
              *ngFor="let role of roles | keyvalue: preserveOriginalOrder"
              [ngValue]="role.key"
            >
              {{ role.value | translate }}
            </option>
          </select>
        </c11n-select>
      </div>

      <div class="form-field" *ngIf="isStudent">
        <label c11n-label for="learningQuizGradeLevel">
          {{ 'formFields.gradeLevel' | translate }}
        </label>
        <c11n-select
          [hideLabel]="true"
          [hintText]="''"
          [hasError]="hasError('gradeLevel')"
          errorText="{{ 'formErrors.grade.required' | translate }}"
        >
          <select
            c11nSelectInput
            required
            id="learningQuizGradeLevel"
            name="gradeLevel"
            formControlName="gradeLevel"
            [attr.aria-invalid]="hasError('gradeLevel')"
          >
            <option value="" data-option="placeholder" disabled selected>
              {{ 'formFields.select' | translate }}
            </option>
            <option
              *ngFor="let grade of grades | keyvalue: preserveOriginalOrder"
              [ngValue]="grade.key"
            >
              {{ grade.value }}
            </option>
          </select>
        </c11n-select>
      </div>

      <div class="form-field">
        <label c11n-label for="learningQuizReference">
          {{ 'formFields.reference' | translate }}
        </label>
        <c11n-select
          [hideLabel]="true"
          [hintText]="''"
          [hasError]="hasError('howDidYouKnowAboutUs')"
          errorText="{{ 'formErrors.reference.required' | translate }}"
        >
          <select
            c11nSelectInput
            required
            id="learningQuizReference"
            name="howDidYouKnowAboutUs"
            formControlName="howDidYouKnowAboutUs"
            [attr.aria-invalid]="hasError('howDidYouKnowAboutUs')"
          >
            <option value="" data-option="placeholder" disabled selected>
              {{ 'formFields.select' | translate }}
            </option>
            <option
              *ngFor="
                let reference of references | keyvalue: preserveOriginalOrder
              "
              [ngValue]="reference.key"
            >
              {{ reference.value }}
            </option>
          </select>
        </c11n-select>
      </div>

      <div
        class="form-field form-field--full school-section"
        *ngIf="requiresSchool"
      >
        <ng-container *ngIf="!enableAddSchoolMode">
          <ng-container
            [ngTemplateOutlet]="
              selectedSchoolMetaData?.schoolMetaDataId
                ? selectedSchoolFromSearch
                : schoolSearchTemplate
            "
          >
          </ng-container>
        </ng-container>

        <div *ngIf="enableAddSchoolMode" class="manual-school">
          <div class="back-to-search">
            <a
              c11n-link
              [iconName]="'search'"
              [variant]="'primary-independent'"
              [iconPosition]="'leading'"
              [fontWeight]="'bold'"
              href="javascript:void(0)"
              (click)="returnToSearch()"
            >
              {{
                'formFields.schoolSearch.return_to_school_search' | translate
              }}
            </a>
          </div>

          <div class="manual-school__fields">
            <div class="form-field">
              <label c11n-label for="learningQuizSchoolCountryRegion">{{
                'formFields.country' | translate
              }}</label>
              <c11n-select
                [size]="'medium'"
                [hideLabel]="true"
                [hintText]="''"
                (stateChange)="onSchoolAddressCountryChange($event)"
              >
                <select
                  c11nSelectInput
                  formControlName="schoolcountryregion"
                  id="learningQuizSchoolCountryRegion"
                >
                  <option
                    *ngFor="
                      let country of countries | keyvalue: preserveOriginalOrder
                    "
                    [value]="country.value"
                  >
                    {{ 'countries.' + country.key | translate }}
                  </option>
                </select>
              </c11n-select>
            </div>

            <div class="form-field form-field--full">
              <label c11n-label for="learningQuizSchoolName">{{
                'formFields.school' | translate
              }}</label>
              <c11n-input [size]="'medium'" [hasError]="hasError('schoolName')">
                <input
                  c11nInput
                  formControlName="schoolName"
                  type="text"
                  required
                  id="learningQuizSchoolName"
                  aria-describedby="learningQuizSchoolName-description"
                  [attr.aria-invalid]="hasError('schoolName')"
                />
              </c11n-input>
              <c11n-hint-error
                [hasError]="hasError('schoolName')"
                [hintErrorId]="'learningQuizSchoolName-description'"
                [errorText]="
                  (hasControlError('schoolName', 'required')
                    ? 'formErrors.school.required'
                    : hasControlError('schoolName', 'maxlength')
                    ? 'formErrors.school.max'
                    : 'formErrors.school.specialCharacters'
                  ) | translate
                "
                [size]="'medium'"
              >
              </c11n-hint-error>
            </div>

            <div class="form-field form-field--wide">
              <label c11n-label for="learningQuizSchoolStreetAddress">{{
                'formFields.streetAddress' | translate
              }}</label>
              <c11n-input
                [size]="'medium'"
                [hasError]="hasError('schoolstreetaddress')"
              >
                <input
                  c11nInput
                  formControlName="schoolstreetaddress"
                  type="text"
                  required
                  id="learningQuizSchoolStreetAddress"
                  aria-describedby="learningQuizSchoolStreetAddress-description"
                  [attr.aria-invalid]="hasError('schoolstreetaddress')"
                />
              </c11n-input>
              <c11n-hint-error
                [hasError]="hasError('schoolstreetaddress')"
                [hintErrorId]="'learningQuizSchoolStreetAddress-description'"
                [errorText]="
                  (hasControlError('schoolstreetaddress', 'required')
                    ? 'formErrors.streetAddress.required'
                    : hasControlError('schoolstreetaddress', 'maxlength')
                    ? 'formErrors.streetAddress.max'
                    : 'formErrors.streetAddress.specialCharacters'
                  ) | translate
                "
                [size]="'medium'"
              >
              </c11n-hint-error>
            </div>

            <div class="form-field">
              <label c11n-label for="learningQuizSchoolSecondaryAddressUnit">{{
                'formFields.secondaryAddressUnit' | translate
              }}</label>
              <c11n-input
                [size]="'medium'"
                [hasError]="hasError('schoolsecondaryaddressunit')"
              >
                <input
                  c11nInput
                  formControlName="schoolsecondaryaddressunit"
                  type="text"
                  id="learningQuizSchoolSecondaryAddressUnit"
                  aria-describedby="learningQuizSchoolSecondaryAddressUnit-description"
                  [attr.aria-invalid]="hasError('schoolsecondaryaddressunit')"
                />
              </c11n-input>
              <c11n-hint-error
                [hasError]="hasError('schoolsecondaryaddressunit')"
                [hintErrorId]="
                  'learningQuizSchoolSecondaryAddressUnit-description'
                "
                [errorText]="
                  (hasControlError('schoolsecondaryaddressunit', 'maxlength')
                    ? 'formErrors.secondaryAddressUnit.max'
                    : 'formErrors.secondaryAddressUnit.specialCharacters'
                  ) | translate
                "
                [size]="'medium'"
              >
              </c11n-hint-error>
            </div>

            <div class="form-field form-field--wide">
              <label c11n-label for="learningQuizSchoolCity">{{
                'formFields.city' | translate
              }}</label>
              <c11n-input [size]="'medium'" [hasError]="hasError('schoolcity')">
                <input
                  c11nInput
                  formControlName="schoolcity"
                  type="text"
                  required
                  id="learningQuizSchoolCity"
                  aria-describedby="learningQuizSchoolCity-description"
                  [attr.aria-invalid]="hasError('schoolcity')"
                />
              </c11n-input>
              <c11n-hint-error
                [hasError]="hasError('schoolcity')"
                [hintErrorId]="'learningQuizSchoolCity-description'"
                [errorText]="
                  (hasControlError('schoolcity', 'required')
                    ? 'formErrors.city.required'
                    : hasControlError('schoolcity', 'maxlength')
                    ? 'formErrors.city.max'
                    : 'formErrors.city.specialCharacters'
                  ) | translate
                "
                [size]="'medium'"
              >
              </c11n-hint-error>
            </div>

            <div class="form-field" *ngIf="!isSchoolCountryCanada">
              <label c11n-label for="learningQuizSchoolState">{{
                'formFields.state' | translate
              }}</label>
              <c11n-input
                [size]="'medium'"
                [hasError]="hasError('schoolstate')"
              >
                <input
                  c11nInput
                  formControlName="schoolstate"
                  type="text"
                  required
                  maxlength="2"
                  (input)="
                    quizForm
                      .get('schoolstate')
                      ?.setValue($any($event.target).value?.toUpperCase())
                  "
                  autocapitalize="characters"
                  id="learningQuizSchoolState"
                  aria-describedby="learningQuizSchoolState-description"
                  [attr.aria-invalid]="hasError('schoolstate')"
                />
              </c11n-input>
              <c11n-hint-error
                [hasError]="hasError('schoolstate')"
                [hintErrorId]="'learningQuizSchoolState-description'"
                [errorText]="
                  (hasControlError('schoolstate', 'required')
                    ? 'formErrors.state.required'
                    : 'formErrors.state.invalid'
                  ) | translate
                "
                [size]="'medium'"
              >
              </c11n-hint-error>
            </div>

            <div class="form-field" *ngIf="isSchoolCountryCanada">
              <label c11n-label for="learningQuizSchoolProvince">{{
                'formFields.province' | translate
              }}</label>
              <c11n-select
                [hideLabel]="true"
                [hintText]="''"
                [hasError]="hasError('schoolstate')"
                errorText="{{ 'formErrors.province.required' | translate }}"
              >
                <select
                  c11nSelectInput
                  required
                  formControlName="schoolstate"
                  id="learningQuizSchoolProvince"
                  [attr.aria-invalid]="hasError('schoolstate')"
                >
                  <option value="" data-option="placeholder" disabled selected>
                    {{ 'formFields.select' | translate }}
                  </option>
                  <option
                    *ngFor="let province of provinces"
                    [value]="province.canadianProvinceCode"
                  >
                    {{ province.name }}
                  </option>
                </select>
              </c11n-select>
            </div>

            <div class="form-field">
              <label c11n-label for="learningQuizSchoolZipCode">{{
                'formFields.schoolSearch.schoolZipCode' | translate
              }}</label>
              <c11n-input [size]="'medium'" [hasError]="hasError('zipCode')">
                <input
                  c11nInput
                  formControlName="zipCode"
                  type="text"
                  required
                  id="learningQuizSchoolZipCode"
                  aria-describedby="learningQuizSchoolZipCode-description"
                  [attr.aria-invalid]="hasError('zipCode')"
                />
              </c11n-input>
              <c11n-hint-error
                [hasError]="hasError('zipCode')"
                [hintErrorId]="'learningQuizSchoolZipCode-description'"
                [errorText]="
                  (hasControlError('zipCode', 'required')
                    ? 'formErrors.zipCode.required'
                    : 'formErrors.zipCode.invalid'
                  ) | translate
                "
                [size]="'medium'"
              >
              </c11n-hint-error>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</form>

<ng-template #schoolSearchTemplate>
  <div
    role="search"
    class="c11n-search c11n-search--medium c11n-search--below c11n-search--attached c11n-search--on-light"
  >
    <c11n-search
      [id]="'myce_search_school'"
      [labelText]="'formFields.schoolSearch.search_label' | translate"
      [hasMenu]="false"
      (stateChange)="onSearchAction($event)"
      [attr.aria-describedby]="'myce_search_school-input-description'"
    ></c11n-search>
    <c11n-hint-error
      *ngIf="hasSchoolSearchError"
      [hasError]="hasSchoolSearchError"
      [hintErrorId]="'myce_search_school-input-description'"
      [errorText]="'formErrors.school.required' | translate"
      [size]="'medium'"
    >
    </c11n-hint-error>

    <div
      *ngIf="triggeredSchoolSearch"
      class="c11n-menu c11n-search__menu"
      role="menu"
      id="learning-quiz-school-menu"
    >
      <div class="c11n-menu__menu c11n-search__menu__menu">
        <div class="c11n-menu__group" role="group">
          <button
            *ngFor="let school of schools; trackBy: trackBySchoolId"
            [attr.aria-label]="school.schoolName"
            type="button"
            class="c11n-menu__item c11n-search__menu__item"
            role="menuitem"
            (click)="onSchoolSelect(school)"
          >
            <span class="c11n-search__menu__item_label">{{
              school.schoolName
            }}</span>
          </button>
        </div>

        <div class="c11n-search__menu__summary">
          <div
            class="c11n-search__menu__summary__heading"
            [ngSwitch]="schools.length"
          >
            <ng-container *ngSwitchCase="0">{{
              'formFields.schoolSearch.noResults' | translate
            }}</ng-container>
            <ng-container *ngSwitchCase="1">{{
              'formFields.schoolSearch.oneResult' | translate
            }}</ng-container>
            <ng-container *ngSwitchDefault>{{
              'formFields.schoolSearch.multipleResults'
                | translate: { dynamicText: schools.length }
            }}</ng-container>
          </div>
          <button
            type="button"
            class="c11n-menu__item c11n-search__menu__item c11n-search__menu__summary__see-all"
            role="menuitem"
            (click)="onManualAdd()"
          >
            <span class="c11n-search__menu__item__label">
              <span class="c11n-menu__item-label">{{
                'formFields.schoolSearch.addSchoolManually' | translate
              }}</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #selectedSchoolFromSearch>
  <div class="selected-school-container">
    <div class="back-to-search">
      <a
        c11n-link
        [iconName]="'search'"
        [variant]="'primary-independent'"
        [iconPosition]="'leading'"
        [fontWeight]="'bold'"
        href="javascript:void(0)"
        (click)="onSearchNewSchool()"
      >
        {{ 'formFields.schoolSearch.newSearch' | translate }}
      </a>
    </div>
    <div class="selected-school">
      <div class="selected-school__name">
        <div class="selected-school__name__text">
          {{ 'formFields.schoolSearch.schoolName' | translate }}
        </div>
        <div class="selected-school__name__value">
          {{ selectedSchoolMetaData?.schoolName }}
        </div>
      </div>
      <div class="selected-school__zip">
        <div class="selected-school__zip__text">
          {{ 'formFields.schoolSearch.schoolZipCode' | translate }}
        </div>
        <div class="selected-school__zip__value">
          {{ selectedSchoolMetaData?.zipCode }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
